/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {PitchBookCrmSettings} from '../models/PitchBookCrmSettings';

export interface GetPitchBookCrmSettings$Request {
    accountId: number;
}

export interface GetPitchBookCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPitchBookCrmSettingsRequest = createAction<PayloadData<void, GetPitchBookCrmSettings$Request>>('PITCH_BOOK_CONTROLLER__GET_PITCH_BOOK_CRM_SETTINGS__REQUEST');
export const getPitchBookCrmSettingsSuccess = createAction<PayloadData<PitchBookCrmSettings, GetPitchBookCrmSettings$Request>>('PITCH_BOOK_CONTROLLER__GET_PITCH_BOOK_CRM_SETTINGS__SUCCESS');
export const getPitchBookCrmSettingsFailure = createAction<PayloadData<Error, GetPitchBookCrmSettings$Request, true>>('PITCH_BOOK_CONTROLLER__GET_PITCH_BOOK_CRM_SETTINGS__FAILURE');

export const getPitchBookCrmSettingsActions = [
    getPitchBookCrmSettingsRequest,
    getPitchBookCrmSettingsSuccess,
    getPitchBookCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPitchBookCrmSettings = (meta: GetPitchBookCrmSettings$Request, config?: GetPitchBookCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getPitchBookCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/pitchbook/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SavePitchBookCrmSettings$Request {
    accountId: number;
    pitchBookCrmSettings?: PitchBookCrmSettings;
}

export interface SavePitchBookCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const savePitchBookCrmSettingsRequest = createAction<PayloadData<void, SavePitchBookCrmSettings$Request>>('PITCH_BOOK_CONTROLLER__SAVE_PITCH_BOOK_CRM_SETTINGS__REQUEST');
export const savePitchBookCrmSettingsSuccess = createAction<PayloadData<void, SavePitchBookCrmSettings$Request>>('PITCH_BOOK_CONTROLLER__SAVE_PITCH_BOOK_CRM_SETTINGS__SUCCESS');
export const savePitchBookCrmSettingsFailure = createAction<PayloadData<Error, SavePitchBookCrmSettings$Request, true>>('PITCH_BOOK_CONTROLLER__SAVE_PITCH_BOOK_CRM_SETTINGS__FAILURE');

export const savePitchBookCrmSettingsActions = [
    savePitchBookCrmSettingsRequest,
    savePitchBookCrmSettingsSuccess,
    savePitchBookCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {PitchBookCrmSettings} [meta.pitchBookCrmSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const savePitchBookCrmSettings = (meta: SavePitchBookCrmSettings$Request, config?: SavePitchBookCrmSettings$Config) => {
    return {
        CALL_API: {
            types: savePitchBookCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/pitchbook/settings`,
            TRANSPORT_REQUEST_BODY: meta.pitchBookCrmSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

